import { useQuery } from "@tanstack/react-query";
import { getHarvestConfig } from "../api/harvestApi";

export function useHarvestConfig() {
  return useQuery({
    queryKey: ["harvest", "config"],
    queryFn: () => getHarvestConfig(),
  });
}
